/**
 * New Collection Section JavaScript
 * With AJAX Pagination Support
 */

document.addEventListener("DOMContentLoaded", function () {
  // Initial load with slight delay for DOM readiness
  setTimeout(function () {
    initializeCollectionSection();
  }, 500);
});

/**
 * Main initialization function
 */
function initializeCollectionSection() {
  initializeProductCards();
  initializeCollectionTabs();
  initializeMainSlider();
  initializeProductSliders();
}

/**
 * Handle Slick Sliders - Can be called multiple times
 * This is the key function that AJAX pagination will call
 */
function handleSlickSliders() {
  // Destroy existing sliders first to avoid duplicates
  destroyAllSliders();
  
  // Small delay to ensure DOM is updated
  setTimeout(function() {
    initializeMainSlider();
    initializeProductSliders();
  }, 100);
}

/**
 * Destroy all Slick sliders
 */
function destroyAllSliders() {
  if (typeof $ === 'undefined' || !$.fn.slick) return;
  
  try {
    // Destroy main collection sliders
    $('.new_collection .collection_main').each(function() {
      if ($(this).hasClass('slick-initialized')) {
        $(this).slick('unslick');
      }
    });
    
    // Destroy product image sliders
    $('.new_collection .slider-for').each(function() {
      if ($(this).hasClass('slick-initialized')) {
        $(this).slick('unslick');
      }
    });
    
    $('.new_collection .slider-nav').each(function() {
      if ($(this).hasClass('slick-initialized')) {
        $(this).slick('unslick');
      }
    });
  } catch (error) {
    console.log('Error destroying sliders:', error);
  }
}

/**
 * Product Card Variant Selection & Quick Buy
 */
function initializeProductCards() {
  document.querySelectorAll(".new_collection .card-wrapper").forEach(cardWrapper => {
    const variantSelect = cardWrapper.querySelector(".new_collection .variant_select");
    const colorSwatches = cardWrapper.querySelectorAll(".new_collection .color_swatch, .new_collection .jod-quick-buy-button");
    const quickBuyButtons = cardWrapper.querySelectorAll(".new_collection .jod-quick-buy-button");
    const allInteractiveElements = cardWrapper.querySelectorAll(".new_collection .color_swatch, .new_collection .jod-quick-buy-button");
    const submitButton = cardWrapper.querySelector(".new_collection button#ProductSubmitButton-");
    const variantIdInput = cardWrapper.querySelector(".new_collection .product-variant-id");
    const quickBuyTitle = cardWrapper.querySelector(".new_collection .jod-quick-buy-title");
    const cardMedia = cardWrapper.querySelector(".new_collection .card--media");

    if (!variantSelect || !colorSwatches.length || !variantIdInput) return;

    const toggleActive = (isActive) => {
      cardWrapper.classList.toggle("active", isActive);
    };

    if (quickBuyTitle) {
      quickBuyTitle.addEventListener("click", () => {
        document.querySelectorAll(".new_collection .card-wrapper").forEach(wrapper => {
          if (wrapper !== cardWrapper) {
            wrapper.classList.remove("active");
          }
        });
        toggleActive(!cardWrapper.classList.contains("active"));
      });
    }

    if (cardMedia) {
      cardMedia.addEventListener("mouseleave", () => {
        cardWrapper.classList.remove("active");
      });
    }

    variantSelect.selectedIndex = 0;
    variantIdInput.value = variantSelect.value;

    const initialOptions = variantSelect.options[0].dataset.options.split("|");

    colorSwatches.forEach(swatch => {
      const optionIndex = parseInt(swatch.dataset.optionIndex);
      const optionValue = swatch.dataset.optionValue;

      if (initialOptions[optionIndex] === optionValue) {
        swatch.classList.add("active");
      }

      swatch.addEventListener("click", () => {
        initialOptions[optionIndex] = optionValue;

        cardWrapper.querySelectorAll(`[data-option-index="${optionIndex}"]`).forEach(el => {
          el.classList.remove("active");
        });

        swatch.classList.add("active");

        for (let option of variantSelect.options) {
          if (option.dataset.options === initialOptions.join("|")) {
            variantSelect.value = option.value;
            variantIdInput.value = option.value;
            break;
          }
        }
      });
    });

    variantSelect.addEventListener("change", () => {
      variantIdInput.value = variantSelect.value;
    });

    const clickableElements = quickBuyButtons.length ? quickBuyButtons : allInteractiveElements;
    clickableElements.forEach(element => {
      element.addEventListener("click", () => {
        if (submitButton) {
          submitButton.click();
        }
      });
    });
  });
}

/**
 * Collection Tab Switching
 */
function initializeCollectionTabs() {
  const buttons = document.querySelectorAll(".new_collection .title_inner button");
  const collections = document.querySelectorAll(".new_collection .product_inner .collection_main");

  if (collections.length) {
    collections[0].style.display = "block";
  }

  if (buttons.length) {
    buttons[0].classList.add("active");
  }

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      const index = button.dataset.indexIdPxl;

      buttons.forEach(btn => btn.classList.remove("active"));
      button.classList.add("active");

      collections.forEach(col => {
        col.style.display = col.dataset.index === index ? "grid" : "none";
      });

      // Refresh sliders after tab change
      if (typeof $ !== 'undefined' && $.fn.slick) {
        setTimeout(function() {
          $('.new_collection .collection_main').each(function() {
            if ($(this).hasClass('slick-initialized')) {
              $(this).slick('refresh');
            }
          });
          
          $('.new_collection .card__inner.custom_product').each(function() {
            const $sliderFor = $(this).find('.slider-for');
            const $sliderNav = $(this).find('.slider-nav');
            
            if ($sliderFor.hasClass('slick-initialized')) {
              $sliderFor.slick('setPosition');
            }
            if ($sliderNav.hasClass('slick-initialized')) {
              $sliderNav.slick('setPosition');
            }
          });
        }, 50);
      }
    });
  });
}

/**
 * Main Collection Slider (Product Grid)
 */
function initializeMainSlider() {
  if (typeof $ === 'undefined' || !$.fn.slick) {
    console.error('Slick slider not loaded');
    return;
  }

  // Initialize only sliders that aren't already initialized
  $('.new_collection .collection_main').each(function() {
    if (!$(this).hasClass('slick-initialized')) {
      $(this).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
        prevArrow: '<button type="button" class="slick-prev alpha-arrow alpha-arrow-prev" aria-label="Previous"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next alpha-arrow alpha-arrow-next" aria-label="Next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: false,
        lazyLoad: 'ondemand',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }
  });
}

/**
 * Product Image Sliders (Main + Thumbnails)
 */
function initializeProductSliders() {
  if (typeof $ === 'undefined' || !$.fn.slick) {
    console.error('Slick slider not loaded');
    return;
  }

  $('.new_collection .card__inner.custom_product').each(function() {
    const $sliderFor = $(this).find('.slider-for');
    const $sliderNav = $(this).find('.slider-nav');

    // Only initialize if not already initialized
    if (!$sliderFor.hasClass('slick-initialized')) {
      $sliderFor.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        draggable: false,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev alpha-arrow alpha-arrow-prev" aria-label="Previous"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next alpha-arrow alpha-arrow-next" aria-label="Next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        fade: true,
        asNavFor: $sliderNav,
        lazyLoad: 'ondemand'
      });
    }

    if (!$sliderNav.hasClass('slick-initialized')) {
      $sliderNav.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: $sliderFor,
        dots: false,
        infinite: false,
        centerMode: false,
        arrows: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4
            }
          }
        ]
      });

      $sliderNav.find('.slick-slide').removeClass('slick-current');
      $sliderNav.find('.slick-slide[data-slick-index="0"]').addClass('slick-current');

      $sliderFor.on('afterChange', function(event, slick, currentSlide) {
        $sliderNav.find('.slick-slide').removeClass('slick-current');
        $sliderNav.find('.slick-slide[data-slick-index="' + currentSlide + '"]').addClass('slick-current');
      });
    }
  });
}

/**
 * Shopify Theme Editor Support
 */
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('new_collection')) {
      setTimeout(function() {
        initializeCollectionSection();
      }, 500);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    if (event.target.classList.contains('new_collection')) {
      destroyAllSliders();
    }
  });
}